/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIGuestRequestAutocompleteSuggestion
 */
export interface APIGuestRequestAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestAutocompleteSuggestion
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestAutocompleteSuggestion
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestAutocompleteSuggestion
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestAutocompleteSuggestion
     */
    status?: string;
}

/**
 * Check if a given object implements the APIGuestRequestAutocompleteSuggestion interface.
 */
export function instanceOfAPIGuestRequestAutocompleteSuggestion(value: object): value is APIGuestRequestAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIGuestRequestAutocompleteSuggestionFromJSON(json: any): APIGuestRequestAutocompleteSuggestion {
    return APIGuestRequestAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIGuestRequestAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'company': json['company'] == null ? undefined : json['company'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function APIGuestRequestAutocompleteSuggestionToJSON(value?: APIGuestRequestAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'company': value['company'],
        'status': value['status'],
    };
}

